import header from './header';

let $menu = $('.menu');
let $item = $menu.find('.menu__item');

function scrollToElement(element) {
	if (!element) {
		return;
	}

	if (element === '/') {
		$('html, body').stop().animate({
			scrollTop: 0,
		}, 750);

		return;
	}

	let $element = $(element);

	if (!$element.length) {
		return;
	}

	let headerHeight = $(window).width() > 1024 ? 0 : $('.header').height();
	let position = $element.offset().top - headerHeight;

	$('html, body').stop().animate({
		scrollTop: position,
	}, 750);
}

$item.on('click', (e) => {
	e.preventDefault();

	let href = e.currentTarget.getAttribute('href');

	// TODO: это логику стоит пересмотреть
	if (location.pathname !== '/' && href !== '/') {
		href += +$('.article:visible').data('article');
	}

	header.deactivate();

	scrollToElement(href);
});

export default {
	scrollToElement,
};
